/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_New_TitleInputs */

const en_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New API Key`)
};

const fr_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle clé API`)
};

const de_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer API-Schlüssel`)
};

const it_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova chiave API`)
};

const ru_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый ключ API`)
};

const es_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva clave API`)
};

const zh_cn2_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新 API 密钥`)
};

const ja_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいAPIキー`)
};

const hi_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई एपीआई कुंजी`)
};

const pt_pt2_options_api_keys_new_title = /** @type {(inputs: Options_Api_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova chave de API`)
};

/**
* | output |
* | --- |
* | "New API Key" |
*
* @param {Options_Api_Keys_New_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_new_title = /** @type {((inputs?: Options_Api_Keys_New_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_New_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_new_title(inputs)
	if (locale === "de") return de_options_api_keys_new_title(inputs)
	if (locale === "it") return it_options_api_keys_new_title(inputs)
	if (locale === "ru") return ru_options_api_keys_new_title(inputs)
	if (locale === "es") return es_options_api_keys_new_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_new_title(inputs)
	if (locale === "ja") return ja_options_api_keys_new_title(inputs)
	if (locale === "hi") return hi_options_api_keys_new_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_new_title(inputs)
	return en_options_api_keys_new_title(inputs)
});